import React from 'react'
import { useTranslation } from 'react-i18next'

import type { CoreParkingSpot } from '../../../common/validations/contractParkingSpotsSchema'
import { fmtCurrency, totalPrice } from './parkingSpots.helpers'
import { paymentTypeName, spotPricesFor } from './uiSelectors'

export interface ParkingSpotPriceProps {
  spot: CoreParkingSpot
  atISO: string | null
  isComplimentary: boolean
  className?: string
}

export const ParkingSpotPrice: React.FC<ParkingSpotPriceProps> = ({
  spot,
  atISO,
  isComplimentary,
  className,
}) => {
  const { t, i18n } = useTranslation('parking')

  const perMonth = (amount: number) =>
    t('price.perMonth', { amount: fmtCurrency(amount, i18n.language) })

  if (isComplimentary) {
    return (
      <div className={className}>
        {t('price.label')} {t('price.free')}
      </div>
    )
  }

  const prices = spotPricesFor(spot, atISO)

  if (prices.length === 0) return null

  if (prices.length === 1) {
    return (
      <div className={className}>
        {t('price.label')} {perMonth(prices[0].price)}
      </div>
    )
  }

  return (
    <div className={className}>
      <div>{t('price.label')}</div>
      <ul>
        {prices.map((price) => (
          <li key={price.paymentTypeId}>
            {paymentTypeName(price, i18n.language)}: {perMonth(price.price)}
          </li>
        ))}
      </ul>
      <div>
        {t('price.total')} {perMonth(totalPrice(prices))}
      </div>
    </div>
  )
}
